/**
 * Ajaxで読み込んだJSONをテーブルにしてダイアログで表示します。
 *
 * @requires jQuery
 * @param options
 * @returns {*}
 * @constructor
 */
export function MTAppListing(options) {
    const $ = window.jQuery;
    const jsonTableDefaultOptions = {
        // You can set the following options of MTAppJSONTable
        header: null, // [required] Object: Table header
        headerOrder: [], // [required] Array: Order of table header
        itemsRootKey: 'items', // [required] String: The root key of items
        listingTargetKey: 'id', // [required] String: Target key  which is saved value when listing mode is applied
        listingCheckboxType: 'checkbox', // 'checkbox' or 'radio'
        listingTargetEscape: false // [required] Boolean: encodeURIComponent(target value)
    };
    const op = $.extend(
        {
            // Ajax Options
            url: null, // [required] Data API Script URL (ex)http://your-host/mt/mt-data-api.cgi/v1/sites/1/entries
            data: null, // PlainObject: Data to be sent to the server.
            dataType: 'json', // Set this value to ajax options
            cache: false,
            accessToken: null,
            ajaxOptions: null, // Set plane object if you want to overwrite ajax options

            // Dialog
            dialogTitle: '', // Type the title of dialog window
            l10n: null, // Plain Object. Please check the code of l10n section.

            // Callbacks
            cbAfterOpenDialogFirst: null, // Called just after opening the dialog
            cbProcessResponse: null, // Process the response
            cbAjaxDoneFilterJSONTable: null, // Stop executing JSONTable by returning false from this function.
            // If you get JSON from Data API, you might want to set the following function to this option:
            //
            // cbAjaxDoneFilterJSONTable: function(cb, $dialog, response){
            //     return (response.items && response.items.length > 0);
            // },
            cbAjaxDone: null, // Called when data is loaded
            cbAjaxFail: null, // Called when data could not be get
            cbAfterCancel: null, // After clicking the cancel button
            cbAfterOK: null, // After clicking the OK button
            cbAfterSearch: null, // After searching
            cbAfterSearchReset: null, // After resetting the text filter
            cbAfterOpenDialogLast: null, // After opening the dialog
            cbAfterSelectRowUpperTable: null, // function({name: 'cbAfterSelectRowUpperTable'}, $tr, $(this).is(':checked')){}
            cbAfterSelectRowLowerTable: null, // function({name: 'cbAfterSelectRowLowerTable'}, $tr, $(this).is(':checked')){}

            // JSONTable
            jsontable: { ...jsonTableDefaultOptions }
        },
        options
    );
    if (typeof options.jsontable === 'object' && options.jsontable !== null) {
        op.jsontable = $.extend({}, jsonTableDefaultOptions, options.jsontable);
    }

    /* ==================================================
        L10N
    ================================================== */
    const l10n = {};
    if (mtappVars.language === 'ja') {
        l10n.title = '項目を選択';
        l10n.search = '検索';
        l10n.reset = 'リセット';
        l10n.ok = 'OK';
        l10n.cancel = 'キャンセル';
        l10n.select = '選択';
        l10n.selectedItems = '選択された項目';
        l10n.returnDialogTop = 'ダイアログのトップへ戻る';
        l10n.noItems = '該当するデータがありません';
        l10n.ajaxFail = 'データを取得できませんでした';
    } else {
        l10n.title = 'Select items';
        l10n.search = 'Search';
        l10n.reset = 'Reset';
        l10n.ok = 'OK';
        l10n.cancel = 'Cancel';
        l10n.select = 'Select';
        l10n.selectedItems = 'Selected items';
        l10n.returnDialogTop = 'Dialog top';
        l10n.noItems = 'A matched data was not found.';
        l10n.ajaxFail = 'An error occurred while getting data.';
    }
    if (op.l10n) {
        for (let key in op.l10n) {
            l10n[key] = op.l10n[key];
        }
    }
    /*  L10N  */

    /* ==================================================
        Get the MTAppLisging Dialog
    ================================================== */
    if (!$('#mtapplisting-dialog').length) {
        $('body').append('<div id="mtapplisting-dialog"></div>');
    }
    const $dialog = $('#mtapplisting-dialog');
    /*  Get the MTAppLisging Dialog  */

    /* ==================================================
        Bind events to the dialog
    ================================================== */
    if (!$dialog.hasClass('bind-event')) {
        $dialog.addClass('bind-event');
        // OK Button
        $dialog.on('click', '#mtapplisting-dialog-ok', function (e) {
            const triggerId = $(e.delegateTarget).data('triggerId');
            if (!triggerId) {
                return false;
            }

            // Save selected values
            const values = [];
            const $tbody = $('#mtapplisting-tbody1');
            const $tr = $tbody.children('tr');
            if ($tr.length) {
                $tr.each(function () {
                    values.push(
                        $(this)
                            .find('td.' + $tbody.data('target-key') + ' textarea.jsontable-input-hidden')
                            .val()
                    );
                });
            }
            if (values.length > 1) {
                $('#' + triggerId)
                    .val(',' + values.join(',') + ',')
                    .trigger('change.MTAppListing');
            } else {
                $('#' + triggerId)
                    .val(values[0])
                    .trigger('change.MTAppListing');
            }

            if (op.cbAfterOK !== null && typeof op.cbAfterOK === 'function') {
                op.cbAfterOK({ name: 'cbAfterOK' }, $(e.delegateTarget), $('#' + triggerId));
            }

            // Reset trigger
            $(e.delegateTarget).data('triggerId', '');

            return false;
        });
        $dialog.on('click', '#mtapplisting-text-search', function (e) {
            const v = $('#mtapplisting-text-filter').val();
            const searchWords = v.split(/[ \u3000]/);
            const searchWordsCount = searchWords.length;
            $('#mtapplisting-tbody2 tr').each(function () {
                let match = 0;
                const html = this.innerHTML;
                for (let i = 0; i < searchWordsCount; i++) {
                    const reg = new RegExp(searchWords[i], 'i');
                    if (reg.test(html)) {
                        match++;
                    } else {
                        $(this).addClass('hidden');
                        break;
                    }
                }
                if (match === searchWordsCount) {
                    $(this).removeClass('hidden');
                }
            });
            if (op.cbAfterSearch !== null && typeof op.cbAfterSearch === 'function') {
                op.cbAfterSearch({ name: 'cbAfterSearch' }, $(e.delegateTarget));
            }
            return false;
        });
        $dialog.on('keypress', '#mtapplisting-text-filter', function (e) {
            if (e.which == 13) {
                $(this).next().trigger('click');
            }
        });
        $dialog.on('click', '#mtapplisting-search-reset', function (e) {
            $('#mtapplisting-text-filter').val('');
            if (op.cbAfterSearchReset !== null && typeof op.cbAfterSearchReset === 'function') {
                op.cbAfterSearchReset({ name: 'cbAfterSearchReset' }, $(e.delegateTarget));
            }
            $('#mtapplisting-text-search').trigger('click');
            return false;
        });
        $dialog.on('click', '#mtapplisting-dialog-top', function (e) {
            $(e.currentTarget).parent().prev().animate({ scrollTop: 0 }, 600, 'swing');
            return false;
        });
    }
    /*  Bind events to the dialog  */

    return this.each(function () {
        const $this = $(this);

        /* ==================================================
            Set IDs
        ================================================== */
        let $thisId = $this.attr('id');
        if (!$thisId) {
            $thisId = Math.floor(Math.random() * 10000000000000000).toString(36);
            $this.attr('id', $thisId);
        }
        /*  Set IDs  */

        if ($this.prev().is('label')) {
            $this.prev().addClass('d-block w-100 mb-3');
        }
        $this.parent().addClass('form-inline');
        $this
            .after(`<button type="button" class="btn btn-default ml-3">${l10n.select}</button>`)
            .next('button')
            /* ==================================================
                Event of opening the dialog window
            ================================================== */
            .on('click', function (e) {
                // Don't use ".mtDialog()"

                // Set the trigger id
                const $dialog = $('#mtapplisting-dialog').data('triggerId', $thisId);

                if (op.cbAfterOpenDialogFirst !== null && typeof op.cbAfterOpenDialogFirst === 'function') {
                    op.cbAfterOpenDialogFirst({ name: 'cbAfterOpenDialogFirst' }, $dialog, $this, $(e.target));
                }

                // MTAppListing template
                const tmplData = {
                    id: $thisId + '-modal',
                    title: op.dialogTitle ? op.dialogTitle : l10n.title
                };
                const html = `
                    <div id="${tmplData.id}" class="modal" tabindex="-1" aria-labelledby="${tmplData.id}Label" aria-hidden="true">
                        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 id="${tmplData.id}Label" class="modal-title">${tmplData.title}</h5>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <p class="text-center mtapplisting-indicator my-5"><img src="${window.StaticURI}images/indicator.gif" alt="Loading..."></p>
                                <div class="modal-body">
                                    <textarea id="mtapplisting-textarea1" class="mtapplisting-dummy-textarea visually-hidden"></textarea>
                                    <div class="d-flex mb-4">
                                        <input id="mtapplisting-text-filter" type="text" class="form-control me-3" placeholder="${l10n.search}" style="width: 50%">
                                        <button id="mtapplisting-text-search" type="button" class="btn btn-default">${l10n.search}</button>
                                        <button id="mtapplisting-search-reset" type="button" class="btn btn-default ms-3">${l10n.reset}</button>
                                    </div>
                                    <textarea id="mtapplisting-textarea2" class="mtapplisting-dummy-textarea visually-hidden"></textarea>
                                </div>
                                <div class="modal-footer mtapplisting-actions actions-bar">
                                    <button type="button" id="mtapplisting-dialog-ok" class="btn btn-primary" data-bs-dismiss="modal">${l10n.ok}</button>
                                    <button type="button" id="mtapplisting-dialog-cancel" class="btn btn-default" data-bs-dismiss="modal">${l10n.cancel}</button>
                                    <button type="button" id="mtapplisting-dialog-top" class="btn btn-default">${l10n.returnDialogTop}</button>
                                </div>
                            </div>
                        </div>
                    </div>`;

                // Append MTAppListing template to the dialog, and show the dialog
                $dialog
                    .html(html)
                    .children('.modal')
                    .height($(window).height() - 110);
                const $modal = new bootstrap.Modal($dialog.children('.modal')[0], {
                    backdrop: true,
                    keyboard: false,
                    focus: true
                });
                $modal.show();

                // Hide the indicator
                const $indicator = $dialog.find('.mtapplisting-indicator');

                // Options for ajax
                const ajaxOptions = {
                    dataType: op.dataType,
                    url: $this.attr('data-url') ? $this.attr('data-url') : op.url,
                    data: op.data,
                    cache: op.cache
                };
                if (op.accessToken) {
                    ajaxOptions.headers = {
                        'X-MT-Authorization': 'MTAuth accessToken=' + op.accessToken
                    };
                }
                if (op.ajaxOptions) {
                    $.extend(ajaxOptions, op.ajaxOptions);
                }

                // Get JSON by ajax
                $.ajax(ajaxOptions)
                    .done(function (response) {
                        // Process the response
                        if (op.cbProcessResponse !== null && typeof op.cbProcessResponse === 'function') {
                            response = op.cbProcessResponse({ name: 'cbProcessResponse' }, response);
                        }

                        let filterJSONTable = true;
                        if (op.cbAjaxDoneFilterJSONTable !== null && typeof op.cbAjaxDoneFilterJSONTable === 'function') {
                            filterJSONTable = op.cbAjaxDoneFilterJSONTable({ name: 'cbAjaxDoneFilterJSONTable' }, $dialog, response);
                        }

                        // Show the dialog content
                        $indicator.addClass('hidden').next().removeClass('hidden');

                        if (!filterJSONTable) {
                            $dialog
                                .find('div.modal-body')
                                .text(l10n.noItems)
                                .end()
                                .find('div.mtapplisting-actions .ok')
                                .replaceWith('<button type="button" class="btn btn-default disabled" disabled="disabled">挿入</button>')
                                .end()
                                .find('#mtapplisting-dialog-top')
                                .remove();
                            return false;
                        }
                        // Dummy textarea1 options
                        op.jsontable.caption = l10n.selectedItems;
                        op.jsontable.headerPosition = 'top';
                        op.jsontable.footer = false;
                        op.jsontable.items = null;
                        op.jsontable.edit = false;
                        op.jsontable.add = false;
                        op.jsontable.clear = false;
                        op.jsontable.cellMerge = false;
                        op.jsontable.sortable = false;
                        op.jsontable.listingCheckbox = true;
                        op.jsontable.listingTargetKey = op.jsontable.listingTargetKey || 'id';
                        op.jsontable.optionButtons = null;
                        op.jsontable.cbAfterSelectRow = function (cb, $tr, checked) {
                            if (op.jsontable.listingCheckboxType === 'radio') {
                                return false;
                            }
                            let defaultAction = true;
                            if (op.cbAfterSelectRowUpperTable !== null && typeof op.cbAfterSelectRowUpperTable === 'function') {
                                defaultAction = op.cbAfterSelectRowUpperTable({ name: 'cbAfterSelectRowUpperTable' }, $tr, checked);
                            }
                            if (defaultAction) {
                                if (!checked) {
                                    $tr.prependTo('#mtapplisting-tbody2');
                                }
                            }
                        };
                        op.jsontable.cbAfterBuild = function (cb, $container) {
                            $container.find('tbody').attr('id', 'mtapplisting-tbody1');
                        };
                        $('#mtapplisting-textarea1').MTAppJSONTable(op.jsontable);
                        $('#mtapplisting-tbody1')
                            /*.hide()*/
                            .data('target-key', op.jsontable.listingTargetKey)
                            .html('')
                            .sortable({
                                items: 'tr',
                                cursor: 'move',
                                placeholder: 'mtapp-state-highlight'
                            });

                        // Dummy textarea2 options
                        op.jsontable.caption = null; // overwrite
                        op.jsontable.footer = true; // overwrite
                        op.jsontable.items = response; // overwrite
                        op.jsontable.cbAfterSelectRow = function (cb, $tr, checked) {
                            // overwrite
                            let defaultAction = true;
                            if (op.cbAfterSelectRowLowerTable !== null && typeof op.cbAfterSelectRowLowerTable === 'function') {
                                defaultAction = op.cbAfterSelectRowLowerTable({ name: 'cbAfterSelectRowLowerTable' }, $tr, checked);
                            }
                            if (defaultAction) {
                                $('#mtapplisting-textarea1').next().show();
                                if (checked) {
                                    if (op.jsontable.listingCheckboxType === 'radio') {
                                        $('#mtapplisting-tbody1 tr').appendTo('#mtapplisting-tbody2');
                                    }
                                    $tr.find('td').each(function () {
                                        const w = $(this).width();
                                        $(this).width(w + 'px');
                                    });
                                    $tr.appendTo('#mtapplisting-tbody1');
                                }
                            }
                        };
                        op.jsontable.cbAfterBuild = function (cb, $container) {
                            // overwrite
                            $container.find('tbody').attr('id', 'mtapplisting-tbody2');
                            const savedValue = $this.val().replace(/^,|,$/g, '').split(',');
                            if (op.jsontable.listingCheckboxType === 'radio') {
                                $('td[data-value="' + savedValue[0].replace(/\s*/g, '') + '"]')
                                    .parent()
                                    .find('td:first-child input.jsontable-cb')
                                    .prop('checked', true)
                                    .end()
                                    .appendTo('#mtapplisting-tbody1');
                            } else {
                                for (let i = 0, l = savedValue.length; i < l; i++) {
                                    if (op.jsontable.listingTargetKey === 'id') {
                                        $('td[data-value="' + savedValue[i].replace(/\s*/g, '') + '"]')
                                            .parent()
                                            .find('td:first-child input.jsontable-cb')
                                            .trigger('click');
                                    } else {
                                        $('td[data-value="' + savedValue[i] + '"]')
                                            .parent()
                                            .find('td:first-child input.jsontable-cb')
                                            .trigger('click');
                                    }
                                }
                            }
                        };
                        op.jsontable.debug = false;

                        $('#mtapplisting-textarea2').MTAppJSONTable(op.jsontable);
                        if (op.cbAjaxDone !== null && typeof op.cbAjaxDone === 'function') {
                            op.cbAjaxDone({ name: 'cbAjaxDone' }, $dialog);
                        }
                    })
                    .fail(function (jqXHR, status) {
                        $indicator.addClass('hidden');
                        if (jqXHR.status && jqXHR.status == 404) {
                            $dialog.find('div.modal-body').text(jqXHR.status + ' : ' + l10n.ajaxFail);
                        }
                        if (op.cbAjaxFail !== null && typeof op.cbAjaxFail === 'function') {
                            op.cbAjaxFail({ name: 'cbAjaxFail' }, $dialog, jqXHR, status);
                        }
                        $dialog
                            .find('div.mtapplisting-actions')
                            .removeClass('hidden')
                            .find('a.ok')
                            .replaceWith('<p class="action button disabled">挿入</p>')
                            .end()
                            .find('#mtapplisting-dialog-top')
                            .remove();
                    });

                if (op.cbAfterOpenDialogLast !== null && typeof op.cbAfterOpenDialogLast === 'function') {
                    op.cbAfterOpenDialogLast({ name: 'cbAfterOpenDialogLast' }, $dialog, $this);
                }
                return false;
            });
        /*  Event of opening the dialog window  */
    });
}
// end - $.fn.MTAppListing()
